import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys } from '../types';
import { Filter } from '../../../grid/gridFilters/types';
import {
  GetRowsRequest,
  GetSummaryRequest,
  SetFiltersRequest,
  UpdateSettingsRequest,
} from '../../../grid/types/common';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../../grid/gridView/types';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { API_TYPE_EDR } from '../../../webcomponents.constants';

export class CustomRulesDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private response;
  private filters: Array<Filter<ColumnKeys>>;
  private limit = DEFAULT_PAGE_SIZE;
  public companyFilterDataProvider = API_TYPE_EDR;

  constructor(public dependencies: any) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<any> {
    const filters = convertGridFiltersToExtJsFilters(request.filters);
    const pageNumber = request.pageNumber ?? DEFAULT_PAGE_NUMBER;
    const pageSize = request.pageSize ?? DEFAULT_PAGE_SIZE;
    const sortColumnName = request.sortColumnName ?? null;
    const sortDirection = request.sortDirection ?? null;

    let response = this.response;
    if (!response) {
      response = await this.dependencies.api.clients.CustomRules.readRecords(
        pageNumber,
        pageSize,
        sortColumnName,
        sortDirection,
        filters
      ).toPromise();
      this.response = response;
    }

    return {
      summary: `${response.total} items`,
      numItems: response.total,
    };
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    const filters = convertGridFiltersToExtJsFilters(request.filters);
    const pageNumber = request.pageNumber ?? DEFAULT_PAGE_NUMBER;
    const pageSize = request.pageSize ?? DEFAULT_PAGE_SIZE;
    const sortColumnName = request.sortColumnName ?? null;
    const sortDirection = request.sortDirection ?? null;

    let response = this.response;
    if (!response) {
      response = await this.dependencies.api.clients.CustomRules.readRecords(
        pageNumber,
        pageSize,
        sortColumnName,
        sortDirection,
        filters
      ).toPromise();
    } else {
      this.response = null;
    }

    return { rawEvents: response.data };
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    this.filters = request.filters;
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<{}> {
    this.limit = request.pageSize ?? DEFAULT_PAGE_SIZE;
    return {};
  }
}
